import React, {PureComponent, HTMLAttributes, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import Theme from 'Theme'
import cxs from 'cxs/component'

interface Props extends HTMLAttributes<HTMLSpanElement> {
  name: Icomoon
  size?: number
}

class Icomoon extends PureComponent<Props, Props> {
  render() {
    const {name, ...props} = this.props
    return <StyledIcon {...props}>{name}</StyledIcon>
  }
}

export default Icomoon

const StyledIcon = cxs('div')(
  ({size}) =>
    ({
      display: 'inline-block',
      fontFamily: 'logo',
      fontSize: size ? size + 'px' : Theme.fontSize.big,
      textTransform: 'initial',
      lineHeight: 1,
      padding: Theme.size.space[1],
    } as CSSProperties)
)

StyledIcon.propTypes = {
  size: PropTypes.number
}

type Iconmoon =
  | '\uE900'
  | 'l'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Icomoon.tsx